import { memo } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

interface LoginFormActionsProps {
  currentLocale: string;
  isSubmitting: boolean;
  loading: boolean;
}

export const LoginFormActions = memo(function LoginFormActions({ 
  currentLocale, 
  isSubmitting, 
  loading 
}: LoginFormActionsProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex items-center justify-end">
        <Link
          to={`/${currentLocale}/forgot-password`}
          className="text-sm font-medium text-pink-600 hover:text-pink-500 transition-colors"
        >
          {t('auth.forgotPasswordLink')}
        </Link>
      </div>

      <Button
        type="submit"
        className="w-full bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white shadow-lg shadow-pink-500/50"
        disabled={isSubmitting || loading}
        data-testid="login-submit-button"
      >
        {isSubmitting || loading ? (
          t('common.loading')
        ) : (
          <>
            {t('auth.signIn')}
            <ArrowRight className="ml-2 h-4 w-4" />
          </>
        )}
      </Button>
    </>
  );
});

